/**
 * System Parameter Service
 * API calls for system-wide configurable parameters (Admin only)
 */
import BaseApiService from '../base/BaseApiService';
import type { SystemParameter, UpdateSystemParameterRequest } from '@app-types/system-parameter';

class SystemParameterService extends BaseApiService {
  /**
   * Get all system parameters
   */
  async getSystemParameters(): Promise<SystemParameter[]> {
    return this.get<SystemParameter[]>('/system-parameters');
  }

  /**
   * Update a system parameter value by key
   */
  async updateSystemParameter(key: string, value: string): Promise<SystemParameter> {
    const body: UpdateSystemParameterRequest = { value };
    return this.put<SystemParameter>(`/system-parameters/${encodeURIComponent(key)}`, body);
  }
}

export const systemParameterService = new SystemParameterService();
export default systemParameterService;
